import { useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  asyncActionError,
  asyncActionFinish,
  asyncActionStart,
} from "../async/asyncReducer";
import {
  dataFromSnapshot,
  logErrorInFirestore,
} from "../firestore/firestoreService";
import { onSnapshot } from "@firebase/firestore";

export default function useFirestoreDoc({
  query,
  data,
  deps,
  shouldExecute = true,
  returnIfEmpty = false,
  customErrorMessage,
  queryCode = 0,
  id = "",
  params = "",
}) {
  const dispatch = useDispatch();

  // console.log("UFD id", id);
  // console.log("query", query.toString());
  // console.log("data", data.toString());

  useEffect(() => {
    if (!shouldExecute) return;
    dispatch(asyncActionStart(queryCode));
    const unsubscribe = onSnapshot(
      query(),
      (snapshot) => {
        if (!snapshot.exists) {
          if (returnIfEmpty) return;
          dispatch(
            asyncActionError({
              code: "not-found",
              message: customErrorMessage || "Could not find document",
            })
          );
          return;
        }
        data(dataFromSnapshot(snapshot));
        dispatch(asyncActionFinish());
      },
      async (error) => {
        if (returnIfEmpty) return;
        dispatch(asyncActionError(error.message));
        await logErrorInFirestore({
          error: customErrorMessage + " " + error.message,
          firestoreListener: true,
          notes: {
            query: query.toString(),
            queryCode: queryCode,
            errorFull: error.toString(),
            id: id,
            params: params,
          },
        });
      }
    );
    return () => {
      unsubscribe();
      // dispatch(asyncActionFinish());
    };
  }, deps); // eslint-disable-line react-hooks/exhaustive-deps
}
